import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition } from "@mcurros2/microm";
import { ACTAgregar } from "./ACTAgregar";
import { ACTEditar } from "./ACTEditar";
import { ACTProcesar } from "./ACTProcesar";

const columns = () =>
(
    {
        c_proceso_id: new EntityColumn<string>({ name: 'c_proceso_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Proceso ID' }),
        vc_nombre: new EntityColumn<string>({ name: 'vc_nombre', type: 'char', length: 20, flags: c.Edit, prompt: 'Nombre' }),
        c_fileprocess_id: new EntityColumn<string>({ name: 'c_fileprocess_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Fileprocess Id' }),
        vc_filepath: new EntityColumn<string>({ name: 'vc_filepath', type: 'varchar', length: 2048, flags: EntityColumnFlags.None, prompt: 'Filepath' }),
        c_enviar_recibo_status_id: new EntityColumn<string>({ name: 'c_enviar_recibo_status_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Enviar Recibo Status Id' }),
        bt_procesar: new EntityColumn<boolean>({ name: 'bt_procesar', type: 'bit', flags: EntityColumnFlags.add | EntityColumnFlags.edit | EntityColumnFlags.nullable, prompt: 'Procesar' }),
        vc_errores: new EntityColumn<string>({ name: 'vc_errores', type: 'char', length: 0, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Errores' }),
        vc_password: new EntityColumn<string>({ name: 'vc_password', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Password' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        enre_brwStandard: { name: 'enre_brwStandard', keyMappings: { c_proceso_id: 0 } },
    }
)

const clientActions = () => 
(
    {
        ACTAgregar: ACTAgregar,
        ACTEditar: ACTEditar,
        ACTProcesar: ACTProcesar,
    }
)

const procs = () =>
(
    {
        enre_ComprobarPassword: { name: 'enre_ComprobarPassword' }
    }
)

export class EnviarRecibosDef extends EntityDefinition {

    columns = columns();
    views = views();
    clientActions = clientActions();
    procs = procs();

    constructor() {
        super('EnviarRecibos');
    }
}